import type { Prototype } from "../prototype-types";

export const etienneLamoureuxPrototypes: Prototype[] = [
  {
    id: "search-grid-highly-rated-ads-carousel",
    name: "Search grid — highly rated ads carousel",
    path: "/el/search-grid-highly-rated-ads-carousel",
    description:
      "After row 3, a fully promoted horizontal carousel from team Highly rated, same category: ad tiles for 4★+ brands in the results category.",
    owner: "Etienne Lamoureux",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/59a85f24448c423097ff5fc4f8e41f555da122e839e5220b8265f3c4a376fc12.png",
  },
  {
    id: "search-grid-promoted-brand-row",
    name: "Search grid — promoted brand row",
    path: "/el/search-grid-promoted-brand-row",
    description:
      "Search results mock: row 3 combines a 2-wide brand banner with a 4-wide query-aware mini shop, tagged promoted.",
    owner: "Etienne Lamoureux",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/0d59d943ed12e2e5d5dc91e53d2ba4783ef1d3de51096cba4ab1a7beaa5dfd7d.png",
  },
  {
    id: "search-grid-promoted-category-brand-shop",
    name: "Search grid — promoted category brand shop",
    path: "/el/search-grid-promoted-category-brand-shop",
    description:
      "Promoted brand shop atop results when the query is category-like, not a brand: surfaces a brand that sells that category.",
    owner: "Etienne Lamoureux",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5c7fae2c5ef9c1d10bc5dd32ef9bcde7e596adcd602ee4bf10747c46eaa3e6d0.png",
  },
  {
    id: "search-grid-random-spanning-ads",
    name: "Search grid — random 2×2 ad slots",
    path: "/el/search-grid-random-spanning-ads",
    description:
      "Search grid with ads slotted at random positions; each ad spans 2×2 cells (four organic tile slots) with dense auto-flow.",
    owner: "Etienne Lamoureux",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6fdab49a90c930996f63b807b32b7ba7e2db1de50040314c1867ea4db96b9986.png",
  },
];
